(function(global) {
  function init() {
    $.ajax({
      method: 'get',
      url: 'https://easycurrency.significanceapps.com/api/ping',
      success: render
    });
  }
  
  
  function render(data) {
    var contentRestrictedUS = document.querySelectorAll('[data-pristine-contentrestrict-us]');
    var blocked = data.geoplugin_countryCode == 'US';
    
    for (var i = 0; i < contentRestrictedUS.length; i++) {
      var el = contentRestrictedUS[i];
      var action = el.dataset.pristineContentrestrictUs;
      
      if (action == 'show' && blocked) {
        el.style.display = 'block';
      } else if (action == 'block' && blocked) {
        el.style.display = 'none';
      } else if (action == 'show' && !blocked) {
        el.style.display = 'none';
      } else if (action == 'block' && !blocked) {
        el.style.display = 'block';
      }
    }
  }
  
  
  function ready(cb) {
    if (document.readyState == 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  }
  
  ready(init);
})(window);